import { BaseSVGType } from '@/components/common/svg/types/svgTypes.ts';

const TwoHeartsShape = ({
  width = 56,
  height = 56,
  fillColor = '#fff',
  style
}: BaseSVGType) => (
  <svg
    fill={fillColor}
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    style={style}
    width={width}
    height={height}
    viewBox="0 0 548.17 548.169"
  >
    <g>
      <g>
        <path
          d="M529.357,151.583c-31.824-33.048-113.221-7.955-134.028,34.885c-6.12-6.732-12.24-12.24-18.36-16.524
			c-7.344-4.896-15.912-9.792-25.092-12.852c-25.092-13.464-61.2-6.12-80.171,15.3c-20.196,22.644-11.628,63.647-1.836,88.128
			c21.419,56.304,71.604,83.844,118.116,115.668c50.184-30.6,102.815-67.932,136.476-116.892
			C545.27,230.532,563.018,176.676,529.357,151.583z"
        />
        <path
          d="M247.837,174.228c1.836-4.284,4.284-8.568,6.12-12.24c-22.032-18.972-50.796-12.852-71.604,6.12
			c-12.852,11.628-20.808,26.928-25.092,42.84c-11.628-23.868-34.272-44.063-56.304-53.244c-20.808-8.567-46.512-11.628-67.32,0
			c-4.284,2.448-8.568,4.896-12.24,8.568c-4.896,3.672-9.792,8.568-13.464,14.688c-25.092,41.615,15.3,107.712,38.556,142.596
			c20.808,31.212,57.528,77.112,96.084,86.904C190.31,422.7,244.778,346.2,279.661,315.6
			C245.39,274.596,226.417,223.8,247.837,174.228z"
        />
      </g>
    </g>
  </svg>
);

export default TwoHeartsShape;
